import { WillCountry } from '../../../../data/will-countries/will-countries';

export default {
    premium: {
        premiumWills: 'Premium Will Service',
        premiumWills2: 'Premium Personalized Will',
        heroEyebrow: 'Premium Will Service',
        heading: 'Premium Wills for Complex Estate Planning',
        heading2: '',
        subHeading: 'Work one-to-one with an estate planning specialist to plan and customise Wills for complex family, business, overseas asset and cross-border circumstances.',
        heroReassurance: 'Designed for people who need more than a standard online Will.',
        primaryCta: 'Book a meeting',
        startPremiumWill: 'Start Premium Will',
        secondaryCta: 'View pricing',
        heroTrustSession: 'Private planning session',
        heroTrustDrafting: 'Customised drafting',
        heroTrustCrossBorder: 'Cross-border guidance',
        heroImageAlt: 'Estate planning specialist guiding a couple through their Will',
        contactCta: 'Contact Team',
        chatNow: 'Chat Now',
        chatInitialMessage: 'I am interested in the Premium Will Service and would like to get started.',
        maxSupport: 'Max support',
        productDescription: 'Best for people with complex, sensitive or cross-border circumstances who want one-to-one guidance and customised drafting.',
        productSub: '{{price}} for couples',
        forAdditionalCountries: 'for additional countries',
        includes1: 'Customized Last Will and Testament',
        includes2: 'Guardian appointments where relevant',
        includes3: 'Letter to your Executors',
        includes4: 'Letter of Wishes',
        includes5: 'List of Assets and Digital Assets',
        includes6: 'Private estate planning session',
        includes7: 'Professional printing of all documents',
        includes10: 'Unlimited amendments to the Will until it is signed',
        includes8: 'Signing and witnessing support',
        includes9: 'Deed of Temporary Guardianship',
        optionalAddonsHeading: 'Optional next steps',
        storageEditingSubscription: 'Storage and Editing Subscription',
        whoEyebrow: 'Who this is for',
        whoHeading: 'Who Premium Wills are for',
        whoIntro: 'Premium Wills are designed for people whose family, assets, or wishes need a more personal conversation than a standard online flow.',
        for_parents_heading: 'Parents with young children',
        for_parents_body: 'Set clear conditions for when and how your children should inherit your lifelong savings.',
        for_overseasAssets_heading: 'Overseas assets or property',
        for_overseasAssets_body: 'Address overseas property or assets where inheritance tax or cross-border rules may affect your plan.',
        for_businessOwners_heading: 'Business owners or shareholders',
        for_businessOwners_body: 'Think through company interests, succession questions, and how business assets should be handled.',
        for_blendedFamilies_heading: 'Blended families',
        for_blendedFamilies_body: 'Make your wishes clear where family arrangements need careful explanation.',
        for_specificWishes_heading: 'Specific gifts or conditions',
        for_specificWishes_body: 'Document personal wishes, gifts, charities, and instructions with more flexibility.',
        for_highValueEstates_heading: 'High-value or complex estates',
        for_highValueEstates_body: 'Get a guided process where clarity, coordination, and careful drafting matter.',
        for_guidedExperience_heading: 'A more guided experience',
        for_guidedExperience_body: 'Work with a real person before signing important documents.',
        premiumDifferenceEyebrow: 'What makes it premium',
        premiumDifferenceHeading: 'Personal guidance, thoughtful planning, and professionally prepared documents',
        premiumDifferenceBody:
            'With Premium Wills, you are not left to work through every decision alone. Our team takes time to understand your family, assets, executors, guardians, beneficiaries, and wishes, then prepares documents that reflect your circumstances clearly.',
        feature_privateConsultation_heading: 'Private estate planning session',
        feature_privateConsultation_body: 'A focused conversation about your circumstances, priorities, and concerns.',
        feature_planningReview_heading: 'Estate planning review',
        feature_planningReview_body: 'Practical discussion of executors, guardians, gifts, beneficiaries, and distribution wishes.',
        feature_crossBorderSupport_heading: 'Cross-border considerations',
        feature_crossBorderSupport_body:
            'Support identifying where international assets or family circumstances may need extra care, such as inheritance tax or forced heirship concerns.',
        feature_customDrafting_heading: 'Customized drafting',
        feature_customDrafting_body: 'Drafting support for circumstances that may not fit a standard online questionnaire-only flow.',
        feature_signingGuidance_heading: 'Signing and storage guidance',
        feature_signingGuidance_body: 'Clear next steps for signing, witnessing, storage, and future updates where relevant.',
        pricingEyebrow: 'Pricing',
        pricingHeading: 'Personal support from \nplanning to completion',
        pricingBody: 'Premium pricing includes a private estate planning session, customised drafting, and practical support through finalisation.',
        comparisonHeading: 'Different situations need different levels of support',
        comparisonIntro: 'Online Wills work well for straightforward wishes. Premium is for clients who want more guidance, flexibility, and confidence before signing.',
        onlineComparisonLabel: 'Self-guided',
        premiumComparisonLabel: 'Guided by our team',
        onlineComparisonHeading: 'Online Wills',
        onlineComparisonBody:
            'Best suited for straightforward wishes, standard family arrangements, and clients who are comfortable completing the process through the online platform.',
        premiumComparisonHeading: 'Premium Wills',
        premiumComparisonBody:
            'Best suited when your circumstances are more complex, sensitive, international, or important enough that you want a personalized consultation and customized drafting support.',
        comparison_bestFor_label: 'Best for',
        onlineComparison_bestFor: 'Straightforward wishes and standard family arrangements. Suitable for overseas assets with simple wishes.',
        premiumComparison_bestFor: 'Complex families, overseas assets, business interests, or specific wishes.',
        comparison_process_label: 'Process',
        onlineComparison_process: 'Complete the guided online flow at your own pace.',
        premiumComparison_process: 'Start with a private estate planning session and customized drafting support.',
        comparison_support_label: 'Support',
        onlineComparison_support: 'Platform guidance and team support when needed.',
        premiumComparison_support: '1-on-1 private support from our estate planning team throughout the process.',
        comparison_complexity_label: 'Complexity',
        onlineComparison_complexity: 'Suitable when your wishes fit the standard online structure.',
        premiumComparison_complexity: 'Suitable when your circumstances may need more flexibility or review.',
        comparisonQuestion: 'Not sure which service is right for you?',
        questionnaireCta: 'Take the short questionnaire',
        whatYouGetHeading: 'What you get',
        whatYouGetIntro: 'A consultative service built around your family, your assets, and the decisions you want to document clearly.',
        included_consultation_heading: 'Private estate planning session',
        included_consultation_body: 'Meet with a NobleWills estate planning specialist by video call to discuss your circumstances and wishes.',
        included_consultation_bodyWithWitnessing: 'Meet with a NobleWills estate planning specialist in person or by video call to discuss your circumstances and wishes.',
        included_familyReview_heading: 'Family and asset review',
        included_familyReview_body: 'Review family, asset, beneficiary, and cross-border circumstances before drafting begins.',
        included_executorPlanning_heading: 'Executor and guardian planning',
        included_executorPlanning_body: 'Clarify executors, guardians, beneficiaries, gifts, and practical instructions.',
        included_customWill_heading: 'Customized Will drafting',
        included_customWill_body: 'Receive a customized Will prepared from your instructions and reviewed before finalization.',
        included_letterOfWishes_heading: 'Supporting documents',
        included_letterOfWishes_body: 'Prepare supporting documents such as a Letter of Wishes and asset schedule where relevant.',
        included_crossBorderReview_heading: 'Cross-border review',
        included_crossBorderReview_body: 'Identify international considerations that may affect how your estate plan should be structured.',
        included_signingStorageGuidance_heading: 'Signing and storage guidance',
        included_signingStorageGuidance_body: 'Receive clear instructions for signing, witnessing, storage, and future updates.',
        included_witnessing_heading: 'Signing and witnessing support',
        included_witnessing_body: 'Arrange signing and witnessing support where this service is available.',
        included_temporaryGuardianship_heading: 'Temporary guardianship deed',
        included_temporaryGuardianship_body: 'Prepare a Deed of Temporary Guardianship where this service is available.',
        commonSituationsHeading: 'Common situations we help with',
        commonSituationsIntro: 'If any of these sound familiar, Premium support may be a better fit than a standard online flow.',
        situation_children: 'I have children and want to appoint guardians.',
        situation_multiCountryProperty: 'I own property or assets in more than one country.',
        situation_differentExecutors: 'I want different people to manage different parts of my estate.',
        situation_businessShares: 'I have a business, company shares, or partnership interests.',
        situation_familySituation: 'My family situation is not completely straightforward.',
        situation_clearWishes: 'I want to make sure my wishes are clearly documented.',
        descriptionHeading: 'Support for international and country-specific estate planning',
        description:
            'If you have assets, family, executors, or beneficiaries in more than one country, your Will may need extra care. Our team can help identify where country-specific documents or additional coordination may be appropriate.',
        description2: '',
        description3: 'We can write Wills for the following jurisdictions:',
        description4:
            'This list is not exhaustive. If you need support for another country, contact us and we will confirm whether we can assist. Premium Wills are currently prepared in English.',
        how: 'Our process',
        initial: 'Initial consultation',
        initialBody: 'We start with a private conversation to understand your family, assets, priorities, and any cross-border or sensitive circumstances.',
        review: 'Estate planning review',
        reviewBody: 'Our team reviews the information you provide and helps identify practical issues to consider before drafting.',
        drafting: 'Drafting',
        draftingBody: 'We prepare your customized Will and supporting documents based on your instructions and circumstances.',
        finalize: 'Review and finalization',
        finalizeBody: 'You review the draft, ask questions, and request changes before the documents are finalized.',
        sign: 'Signing and next steps',
        signBody: 'We provide clear signing and witnessing guidance, with storage and future update options available where relevant.',
        finalCtaHeading: 'Ready to talk through your estate plan?',
        finalCtaBody: 'Book a private consultation and our team will help you understand whether Premium is the right fit for your family, assets, and wishes.',
        [WillCountry.unitedKingdom]: 'United Kingdom',
        [WillCountry.australia]: 'Australia',
        [WillCountry.unitedStates]: 'United States of America',
        [WillCountry.singapore]: 'Singapore',
        [WillCountry.malaysia]: 'Malaysia',
        [WillCountry.india]: 'India',
        [WillCountry.caymanIslands]: 'Cayman Islands',
        [WillCountry.jersey]: 'Jersey',
        [WillCountry.guernsey]: 'Guernsey',
        [WillCountry.isleOfMan]: 'Isle of Man',
        [WillCountry.thailand]: 'Thailand',
        [WillCountry.vietnam]: 'Vietnam',
        [WillCountry.philippines]: 'Philippines',
        // [WillCountry.mainlandChina]: 'Mainland China',
        [WillCountry.japan]: 'Japan',
        [WillCountry.hongKong]: 'Hong Kong',
        [WillCountry.canada]: 'Canada',
        [WillCountry.newZealand]: 'New Zealand',
        [WillCountry.taiwan]: 'Taiwan',
        [WillCountry.britishVirginIslands]: 'British Virgin Islands',
        [WillCountry.france]: 'France',
        [WillCountry.germany]: 'Germany',
        [WillCountry.italy]: 'Italy',
        [WillCountry.gibraltar]: 'Gibraltar',
        [WillCountry.luxembourg]: 'Luxembourg',
        [WillCountry.ireland]: 'Ireland',
        [WillCountry.israel]: 'Israel',
        // [WillCountry.sweden]: 'Sweden',
        [WillCountry.switzerland]: 'Switzerland',
        [WillCountry.southAfrica]: 'South Africa',
    },
};
